module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Bloquear Atendimentos por Período")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select-procedimento-contrato', {
    attrs: {
      "semAgrupados": 1,
      "contrato-id": _vm.$route.params.distribuicaoContratoId,
      "placeholder": "PROCEDIMENTO"
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select-profissional', {
    attrs: {
      "placeholder": "PROFISSIONAL"
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("AMBOS")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("MASCULINO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("FEMININO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('periodo_de')
    }
  }, [_c('label', [_vm._v("Período (De)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_inicial),
      expression: "filtros.data_inicial"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "periodo_de",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE",
      "name": "periodo_de"
    },
    domProps: {
      "value": (_vm.filtros.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_inicial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('periodo_de')),
      expression: "errors.has('periodo_de')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('periodo_de')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('periodo_ate')
    }
  }, [_c('label', [_vm._v("Período (Até)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_final),
      expression: "filtros.data_final"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "periodo_ate",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE",
      "name": "periodo_ate"
    },
    domProps: {
      "value": (_vm.filtros.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_final", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('periodo_ate')),
      expression: "errors.has('periodo_ate')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('periodo_ate')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('atendimento')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade de ATENDIMENTOS a bloquear em cada ocorrência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_primeira_bloqueada),
      expression: "dados.quantidade_primeira_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_retorno_bloqueada === '') && (_vm.dados.quantidade_local_bloqueada === '') ? 'required' : ''),
      expression: "(dados.quantidade_retorno_bloqueada === '') && (dados.quantidade_local_bloqueada === '') ?'required' : ''"
    }],
    ref: "atendimento",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "atendimento"
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('atendimento')),
      expression: "errors.has('atendimento')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('retorno')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade de RETORNOS a bloquear em cada ocorrência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_retorno_bloqueada),
      expression: "dados.quantidade_retorno_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_primeira_bloqueada === '') && (_vm.dados.quantidade_local_bloqueada === '') ? 'required' : ''),
      expression: "(dados.quantidade_primeira_bloqueada === '') && (dados.quantidade_local_bloqueada === '') ?'required' : ''"
    }],
    ref: "retorno",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "retorno"
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('retorno')),
      expression: "errors.has('retorno')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('local')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade de atendimentos LOCAIS a bloquear em cada ocorrência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_bloqueada),
      expression: "dados.quantidade_local_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_primeira_bloqueada === '') && (_vm.dados.quantidade_retorno_bloqueada === '') ? 'required' : ''),
      expression: "(dados.quantidade_primeira_bloqueada === '') && (dados.quantidade_retorno_bloqueada === '') ?'required' : ''"
    }],
    ref: "local",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "local"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('local')),
      expression: "errors.has('local')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.getOcorrencias
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Calcular número total de ocorrências e bloqueios")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_vm._v("\n              Total de registros encontrados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.registros))])]), _vm._v(" "), _c('p', [_vm._v("\n              Total de atendimentos que serão bloqueados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.atendimentos))])]), _vm._v(" "), _c('p', [_vm._v("\n              Total de retornos que serão bloqueados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.retornos))])]), _vm._v(" "), _c('p', [_vm._v("\n              Total de atendimentos locais que serão bloqueados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.locais))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Confirmar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar\n            ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5f62ae42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/distribuicoes/atendimentos/bloquearPeriodoModal.vue
// module id = 853
// module chunks = 0